/* eslint-disable space-before-function-paren */
import 'jquery.scrollto'
import 'lity'
import $ from 'jquery'
import CONSTS from '../constants'
import Component from './component'
import Easing from 'jquery.easing'
import Packery from 'packery'
import getSize from 'get-size'

export class ProductsBoard extends Component {
  constructor(ctx, ev) {
    super(ctx, ev)

    // classes extensions
    Object.assign(this.classes, {
      grid: '.js-products-board-grid',
      product: '.js-products-board-grid-product',
      detail: '.js-product-detail',
      btnClose: '.js-product-detail-btn-close',
    })

    Object.assign(this.easings, {
      scrollTo: Easing.easeInOutExpo,
    })

    this.$grid = this.$ctx.find(this.classes.grid)
    this.$products = this.$ctx.find(this.classes.product)

    this.makeGrid()
    this.bindProductDetail()
  }

  makeGrid() {
    // @NOTE: centered layout for packery
    const totalProducts = this.$products.length
    const __resetLayout = Packery.prototype._resetLayout
    Packery.prototype._resetLayout = function () {
      __resetLayout.call(this)
      // reset packer
      const parentSize = getSize(this.element.parentNode)
      const colW = this.columnWidth + this.gutter

      this.fitWidth = Math.min(
        Math.floor((parentSize.innerWidth + this.gutter) / colW) * colW,
        totalProducts * colW
      )

      this.packer.width = this.fitWidth
      this.packer.height = Number.POSITIVE_INFINITY
      this.packer.reset()
    }

    Packery.prototype._getContainerSize = function () {
      // remove empty space from fit width
      let emptyWidth = 0
      for (let i = 0, len = this.packer.spaces.length; i < len; i++) {
        const space = this.packer.spaces[i]

        if (space.y === 0 && space.height === Number.POSITIVE_INFINITY) {
          emptyWidth += space.width
        }
      }

      return {
        width: this.fitWidth - this.gutter - emptyWidth,
        height: this.maxY - this.gutter,
      }
    }

    // always resize
    Packery.prototype.needsResizeLayout = function () {
      return true
    }

    this.packery = new Packery(this.$grid[0], {
      itemSelector: this.classes.product,
      columnWidth: 300,
      gutter: 0,
      transitionDuration: 0,
    })
  }

  bindProductDetail() {
    this.$products.on('click', (event) => {
      event.preventDefault()

      const DELAY = 800
      const $me = $(event.currentTarget)
      const id = $me.data('id')
      let $detail = this.$ctx.find(this.classes.detail)

      // close detail…
      if ($detail.length > 0) {
        $detail.removeClass(this.classStates.active)

        // …for current product
        if ($me.hasClass(this.classStates.active)) {
          $me.removeClass(this.classStates.active)

          window.setTimeout(() => {
            this.packery.options.transitionDuration = '0.8s'

            $detail.remove()
            this.packery.layout()

            this.packery.options.transitionDuration = 0
          }, DELAY)

          return
        }

        // …for another product
        this.$products.removeClass(this.classStates.active)

        $detail.remove()
        this.packery.layout()
      }

      $me.addClass(this.classStates.active)

      // ajax load information
      $.ajax({
        type: 'GET',
        url: `${CONSTS.URL + CONSTS.LANG}/product/${id}`,
        dataType: 'html',
        cache: false,
        success: (html) => {
          const $html = $(html)
          const DELAY1 = 50
          const DELAY2 = 800

          window.setTimeout(() => {
            $me.after($html)

            this.packery.options.transitionDuration = '0.8s'

            this.packery.reloadItems()
            this.packery.layout()

            this.packery.options.transitionDuration = 0

            $detail = this.$ctx.find(this.classes.detail)

            window.setTimeout(() => {
              $detail.addClass(this.classStates.active)

              $.scrollTo($me, {
                duration: 800,
                easing: this.easings.scrollTo,
                margin: true,
              })
            }, DELAY2)
          }, DELAY1)
        },
      })
    })

    this.$ctx.on('click', this.classes.btnClose, (event) => {
      event.preventDefault()

      const DELAY = 800
      const $me = $(event.currentTarget)
      const $detail = $me.closest(this.classes.detail)

      if ($detail.length > 0) {
        $detail.removeClass(this.classStates.active)

        window.setTimeout(() => {
          this.packery.options.transitionDuration = '0.8s'

          $detail.remove()
          this.packery.layout()

          this.packery.options.transitionDuration = 0
        }, DELAY)
      }

      this.$products.removeClass(this.classStates.active)
    })
  }

  onResize() {
    // noop
  }
}
